import { Skeleton } from '@mui/material'
import clsx from 'clsx'
import { LoadingTable, Modal, Tabs } from 'components/core-v2'

import classes from './index.module.scss'
import { DEFAULT_COLUMN_DEFS, FOF_COLUMN_DEFS, MODEL_COLUMN_DEFS } from './table-options'
import { ModelAndFundOfFundsPortfolioType } from './types'

interface Props {
  onClose: () => void
  portType: ModelAndFundOfFundsPortfolioType
}
export const Loading = ({ onClose, portType }: Props) => (
  <>
    <Modal.Header id="model-portfolio-modal" onClose={onClose}>
      <h2>{portType === 'ModelPortfolio' ? 'Model' : 'Fund of funds'}</h2>
    </Modal.Header>
    <Modal.Body className={classes.body}>
      <div className={clsx(classes.totals, 'mb-8')}>
        <Skeleton height="15px" width="300px" />
      </div>
      <Tabs.List ruleClassName="mb-4" spacing="md">
        <Tabs.Tab isSelected value="portfolios">
          Portfolios
        </Tabs.Tab>
        <Tabs.Tab isSelected={false} value="rebalancing">
          Rebalancing
        </Tabs.Tab>
        <Tabs.Tab isSelected={false} value="tax-classifications">
          Tax classifications
        </Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel className="flex-1" value="portfolios">
        <LoadingTable
          agGridProps={{
            columnDefs: portType === 'ModelPortfolio' ? MODEL_COLUMN_DEFS : FOF_COLUMN_DEFS,
            defaultColDef: DEFAULT_COLUMN_DEFS,
            headerHeight: 60,
            rowHeight: 44
          }}
          className="flex-1"
          rowCount={6}
        />
      </Tabs.Panel>
    </Modal.Body>
  </>
)
